import React from 'react';
import { TriangleAlertIcon } from 'lucide-react';
import ImportantIcon from '@/Components/TalentMeshIcons/ImportantIcon';

import { Badge, Button, Dialog, DialogContent, DialogTitle, TypographyH3, TypographyP } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';

interface ConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onOk: (event: React.SyntheticEvent) => void;
    onCancel: (event: React.SyntheticEvent) => void;
}

function RecruitmentCloseConfirmDialog({ open, onClose, onOk, onCancel }: ConfirmDialogProps): React.JSX.Element {
    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <DialogContent className="max-w-xl gap-4 p-6" showCloseButton={false}>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-4">
                        <ImportantIcon className="w-auto" />
                        <DialogTitle asChild>
                            <TypographyH3 className="text-primary text-2xl leading-tight font-semibold tracking-tight">
                                {UIStrings.ReadyToCloseThisRecruitment}
                            </TypographyH3>
                        </DialogTitle>
                    </div>
                    <div className="border-border flex flex-col items-start gap-2 rounded-xl border p-3">
                        <Badge variant="default" className="gap-1 bg-amber-600">
                            <TriangleAlertIcon data-icon="inline-start" />
                            Important
                        </Badge>
                        <TypographyP className="text-foreground">{UIStrings.CloseRecruitmentProceed1}</TypographyP>
                        <TypographyP className="text-foreground">{UIStrings.CloseRecruitmentProceed2}</TypographyP>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                        <Button type="button" variant="default-outline" className="flex-1" onClick={onCancel}>
                            {UIStrings.KeepRecruitmentOpen}
                        </Button>
                        <Button type="button" variant="default" className="flex-1" onClick={onOk}>
                            {UIStrings.CloseRecruitment}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default RecruitmentCloseConfirmDialog;
